import { render, staticRenderFns } from "./AuthFootbar.vue?vue&type=template&id=7b2f4ff8"
import script from "./AuthFootbar.vue?vue&type=script&lang=js"
export * from "./AuthFootbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports